import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Col, Row } from "react-bootstrap";
//import FutureOptions from "./../../../Images/futureoptions.png";
import FutureOptions from "./../../../Images/home-products/futureoptions.png";
import FnOFaq from "./FnOFaq/FnOFaq";
import { useCookies } from "react-cookie";
import TrackApi from "../../Activity_Track/TrackApi";
import { useEffect } from "react";
function FnOProduct() {
  const [cookies, setCookie] = useCookies(['LeadId']);
  const trackData=(id)=>{
    const payloadData={
      "RelatedProspectId":id,
      "ActivityNote": "Your FNO Note",
      "mx_Custom_1": "FNO",
      "mx_Custom_2": "FNO page Note",
      "mx_CustomObject_81":window.location.href
     }
     TrackApi(payloadData);
  }
  useEffect(()=>{
  
if(cookies && cookies.RelatedProspectId){
  trackData(cookies.RelatedProspectId);
}
    
  },[])
  return (
    <>
      {/* <div>IPO Product testing</div> */}
      <section className="welcome-equity">
        <Container>
          <Row>
            <Col lg={4} md={6} sm={12}>
              <div className="welcome-img-block">
                <img
                  className="img-fluid"
                  src={FutureOptions}
                  alt="FutureOptions"
                />
              </div>
            </Col>
            <Col lg={8} md={6} sm={12}>
              <div className="welcome-equity-beta">
                <h3>
                  <span>Future and options</span>
                </h3>
                <p>
                  Futures are an exchange-traded standardized derivative
                  agreement to buy or sell the underlying asset at a
                  pre-determined price on a specific date. A stock, index,
                  currency, or commodity can serve as the underlying asset. The
                  contract is directly executed via a regulated and organized
                  exchange and the parties of the futures contract are obligated
                  to carry out the terms of the agreement. Futures are primarily
                  used to hedge commodity price volatility or to profit from
                  price movements, as opposed to buying or selling the actual
                  cash commodity, as is done with stocks.
                </p>
                <p>
                  An options contract gives the right to buyer but not the
                  obligation to buy or sell the underlying asset within a
                  specified date (expiration date) and at a specific price
                  (strike price). Options are standardised derivative contracts
                  whose value is determined by an underlying asset. The buyer of
                  the option contract is not obligated to exercise the option.{" "}
                </p>
                {/* <a>
                  <span>Explore</span>
                </a>
                <button type="button">Sign Up</button> */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="why-equity-block">
        <Container className="add-border">
          <Row>
            <Col lg={12} md={12} sm={12}>
              <div className="why-equitie-inn">
                <h3>
                  <span>Why Futures and options</span>
                </h3>
                <p>
                  Futures are primarily used to hedge commodity price volatility
                  or to profit from price movements, as opposed to buying or
                  selling the actual cash commodity, as is done with stocks.
                  Whereas, an options speculation enables a trader to carry a
                  leveraged position in an asset at a lesser cost than taking a
                  position in an underlying asset. Investors utilize options to
                  hedge or lower their portfolio's risk exposure.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <FnOFaq />
    </>
  );
}
export default FnOProduct;
